import React from 'react'
import { Col, Row } from 'reactstrap'
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useFormikContext } from 'formik'
import { Dropdown, Input } from 'src/components/Forms'
import { Body, Footer } from 'src/components/theme/Models/Modal'
import { UseLookupsReturn } from './useLookups'

interface FormProps {
  toggle: () => void
  isLoading?: boolean
  hasError?: boolean
  disableSave?: boolean
  lookups?: UseLookupsReturn
}

const Form: React.FC<FormProps> = (props) => {
  const { hasError, toggle, isLoading, disableSave } = props
  const {
    portfolioManagers,
    programManagers
  } = props.lookups ?? {}
  const { handleSubmit, isValid } = useFormikContext()
  const canSave = disableSave === false && isValid && isLoading === false
  return (
    <>
      <Body error={{
        error: 'There was an issue adding the contract.',
        show: hasError ?? false
      }}
      >
        <Input type='text' name='name' label='Name' />
        <Input type='text' name='abbreviation' label='Abbreviation' />
        <Dropdown name='portfolio_manager' label='Portfolio Manager' options={portfolioManagers ?? []} />
        <Dropdown name='program_manager' label='PgM/PjM' options={programManagers ?? []} />
        <Input type='number' name='teamSize' label='Team Size' />
        <Input type='text' name='primary_address.street' label='Primary Address' />
        <Row>
          <Col sm={12} md={6}>
            <Input type='text' name='primary_address.city' label='City' />
          </Col>
          <Col sm={12} md={3}>
            <Input type='text' name='primary_address.state' label='State' maxLength={2} />
          </Col>
          <Col sm={12} md={3}>
            <Input type='text' name='primary_address.zip' label='Zip' maxLength={5} />
          </Col>
        </Row>
      </Body>
      <Footer
        toggle={toggle}
        onAction={handleSubmit}
        action={{
          text: 'Create',
          icon: isLoading === true ? faSpinner : faPlus,
          color: 'primary',
          disabled: canSave
        }}
      />
    </>
  )
}

export default Form
